import { type FC, useEffect } from 'preact/compat';

import { usePlaydeckActions } from '@/entities/playdeck/models/playdeck.store';

import { type Game } from '@/shared/api/game/types';
import { connectEruda } from '@/shared/helpers/connect-eruda';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag';
import { useAppState } from '@/shared/stores/app-store/app-store';
import { ButtonSize } from '@/shared/ui/button/types';
import { Button } from '@/shared/ui/button/ui';

import { copyText } from '../lib/copy-text';
import { insertNewLink } from '../lib/insert-new-link';
import { DevBanner } from './DevBanner';
import { TestErrorButtons } from './TestErrorButtons';

import s from './index.module.scss';

interface Props {
  game: Game | null;
}

export const DevMenu: FC<Props> = ({ game }) => {
  const { showDevMenu, gameUrl } = useAppState();
  const { setPlaydeckOpen } = usePlaydeckActions();
  const { isKassir } = useFeatureFlag();
  // const showAd = useAdvertisement('dev');

  // const { show: showAnyAd } = usePrioritizedAdvertisement('dev');

  useEffect(() => {
    if (isKassir) {
      connectEruda();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isKassir) {
    return null;
  }

  return (
    <>
      {showDevMenu && (
        <div className={s['dev-menu']}>
          <h1 className={s.title}>Dev menu</h1>
          <div className={s.content}>
            <div className={s.link}>
              <h2 className={s.subtitle}>links</h2>
              <div className={s.buttons}>
                <Button
                  size={ButtonSize.s30}
                  onClick={() => copyText(window.location.href)}
                >
                  copy link wrapper with game
                </Button>
                <Button
                  size={ButtonSize.s30}
                  onClick={() => copyText(window.location.hash)}
                >
                  copy hash
                </Button>
                <Button size={ButtonSize.s30} onClick={() => copyText(gameUrl ?? 'null')}>
                  copy game link
                </Button>
                <Button
                  size={ButtonSize.s30}
                  onClick={() => insertNewLink(game?.gameUrl)}
                >
                  insert new link (only https)
                </Button>
                <Button size={ButtonSize.s30} onClick={() => setPlaydeckOpen(false)}>
                  close playdeck
                </Button>
              </div>
            </div>
          </div>
          <div className={s['json-viewer']}>
            <h2 className={s.subtitle}>game object on platform</h2>
            <pre className={s.code}>{JSON.stringify(game, null, 2)}</pre>
          </div>

          {/* {isKassir && (
            <div className={s.ads}>
              <h2 className={s.subtitle}>test ads</h2>
              <div className={s.buttons}>
                <Button
                  variant={ButtonVariant.secondary}
                  size={ButtonSize.s30}
                  onClick={() => showAnyAd()}
                >
                  ANY
                </Button>

                {Object.values(AD_NETWORK).map((avdNetwork) => (
                  <Button
                    key={avdNetwork}
                    variant={ButtonVariant.secondary}
                    size={ButtonSize.s30}
                    onClick={() => showAd({ avdNetwork })}
                  >
                    {avdNetwork}
                  </Button>
                ))}
              </div>
              <h2 className={s.subtitle}>Test methods</h2>
              <div className={s.buttons}>
                <Button onClick={() => returnToMarket()}>returnToMarket</Button>
              </div>
            </div>
          )} */}
          <div>
            <h2 className={s.subtitle}>Test Error Logging</h2>
            <TestErrorButtons className={s.section} />
          </div>
        </div>
      )}
      <DevBanner showDevMenu={showDevMenu} />
    </>
  );
};
